import { Dependencies } from '../dependencies';
import { useDoctorAnyIdFilter } from './useDoctorAnyIdFilter';
import { useDoctorAvailabilityFilter } from './useDoctorAvailabilityFilter';
import { useDoctorConditionFilter } from './useDoctorConditionFilter';
import { useDoctorDoctorFilter } from './useDoctorDoctorFilter';
import { useDoctorGenderFilter } from './useDoctorGenderFilter';
import { useDoctorInsuranceFilter } from './useDoctorInsuranceFilter';
import { useDoctorLanguageFilter } from './useDoctorLanguageFilter';
import { useDoctorNameFilter } from './useDoctorNameFilter';
import { useDoctorSearchRadiusFilter } from './useDoctorSearchRadiusFilter';
import { useDoctorSecondarySpecialtyFilter } from './useDoctorSecondarySpecialtyFilter';
import { useDoctorSpecialtyFilter } from './useDoctorSpecialtyFilter';
import { useDoctorTierFilter } from './useDoctorTierFilter';
import { useDoctorYearsExpFilter } from './useDoctorYearsExpFilter';

export const doctorFiltersDependencies = new Dependencies('doctorFiltersDependencies', [
  useDoctorAnyIdFilter,
  useDoctorConditionFilter,
  useDoctorGenderFilter,
  useDoctorLanguageFilter,
  useDoctorNameFilter,
  useDoctorSecondarySpecialtyFilter,
  useDoctorSearchRadiusFilter,
  useDoctorSpecialtyFilter,
  useDoctorTierFilter,
  useDoctorYearsExpFilter,
  useDoctorAvailabilityFilter,
  useDoctorInsuranceFilter,
  useDoctorDoctorFilter,
]);
export const clearDoctorFilters = (...args) => {
  doctorFiltersDependencies.clearDependencies(...args);
};
